<script lang="ts" setup>
import LightArrowIcon from "@/components/icon/LightArrowIcon.vue";
import ChatMessageItem from "@/components/mobile/ChatMessageItem.vue";
import { useRoute, useRouter } from "vue-router";
import { onBeforeMount, ref, watch } from "vue";
import { useMoment } from "@/stores/moment";
import { Moment } from "@/types/entity";
import ThreadsNav from "@/components/mobile/ThreadsNav.vue";

const route = useRoute();
const router = useRouter();
const moment = useMoment();
const currentMoment = ref<Moment | null>(null);
const isLoading = ref(false);
// 内部状态

// Lifecycle
const updateCurrentMoment = async () => {
  isLoading.value = true;
  try {
    const momentUuid = route.params.uuid.toString();
    currentMoment.value = await moment.getOrFetchMomentItem(momentUuid);
  } finally {
    isLoading.value = false;
  }
};
onBeforeMount(() => {
  updateCurrentMoment();
});
watch(
  () => route.params.uuid,
  (uuid) => {
    if (!uuid) {
      return;
    }
    updateCurrentMoment();
  }
);
</script>
<template>
  <div class="h-full grid grid-rows-[auto_1fr]">
    <threads-nav show-back>
      <template #center>
        <div>{{ $t("Texts.chatRecord") }}</div>
      </template>
    </threads-nav>
    <!--  内容区  -->
    <div class="overflow-y-auto">
      <div
        v-if="isLoading"
        class="w-full h-full flex items-center justify-center"
      >
        <span class="loading"></span>
      </div>
      <div v-else class="p-4">
        <chat-message-item
          v-for="item in currentMoment!.chatMessagezz"
          :key="item.id"
          :avatar-url="item.mate.mediaUrl"
          :msg="item.text"
          :name="item.mate.name"
          :position="(currentMoment!.mate.uuid === item.mate.uuid) ? 'end' : 'start'"
        />
      </div>
    </div>
  </div>
</template>
